import type { AvailablePromotion, PromotionDiscount } from "../types/promotionTypes";

export const appliedPromotionIds = (
   sku: string,
   promotionDiscounts: PromotionDiscount[],
   availablePromotions: AvailablePromotion[]
) => {
   const isAvailable = (promotionId: string) => availablePromotions.some(({ id }) => id === promotionId);
   const isLinked = (promotionId: string) =>
      availablePromotions.some(({ id, products }) => id === promotionId && products.includes(sku));

   return promotionDiscounts
      .filter((promotion) => {
         const discountsProduct = promotion.items.some((item) => item.sku === sku);
         const discountsOrder = promotion.orderLevelDiscount > 0 && isLinked(promotion.id);
         return promotion.applicable && isAvailable(promotion.id) && (discountsProduct || discountsOrder);
      })
      .map(({ id }) => id);
};
